import React, { useState } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
import { Heading } from "../../../components";
import { Img } from "../../../components";
import { Button } from "../../../components";
import {useTranslation} from "react-i18next";

export default function FAQSection() {

    const [expandedItems, setExpandedItems] = useState(["item-1"]);

    const handleAccordionChange = (expanded) => {
        setExpandedItems(expanded);
    };

    const {t} = useTranslation();

    const accoridonData = [
        {
            question: t("faq.question.1.title"),
            answer: t("faq.question.1.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.2.title"),
            answer: t("faq.question.2.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.3.title"),
            answer: t("faq.question.3.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.4.title"),
            answer: t("faq.question.4.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.5.title"),
            answer: t("faq.question.5.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.6.title"),
            answer: t("faq.question.6.answer"),
            arrow: "images/img_arrow_up_new.svg"
        },
        {
            question: t("faq.question.6.title"),
            answer: t("faq.question.6.answer"),
            arrow: "images/img_arrow_up_new.svg"
        }
    ];

    const [showAll, setShowAll] = useState(false);

    // Определяем, какие данные показывать (отображаем все элементы, но ограничиваем высоту для анимации)
    const dataToShow = showAll ? accoridonData : accoridonData.slice(0, 6);

    // Функция для прокрутки к секции "ContactFormScrtion"
    const scrollToContactForm = () => {
        const contactSection = document.getElementById("ContactForm");
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Функция переключения состояния показа списка вопросов
    const toggleShowAll = () => {
        setShowAll((prev) => !prev);
    };

    return (
        <section id="FAQ">
            <div className="bg-[#6C6C6C] justify-center py-[74px] px-6 md:px-5 sm:px-[16px]">
                <div className="container-xs mb-1 flex justify-center">
                    <div className="flex w-full items-start gap-5 md:flex-col sm:flex-col">
                        <div className="gap-10 flex w-full flex-col items-start">
                            <div className="flex flex-col items-start gap-5 self-stretch">
                                <Heading
                                    size="desktop_heading_4"
                                    className="  font-medium text-[#FFFFFFB8] leading-[33.6px] gap-4 uppercase">
                                    {t("faq.title")}
                                </Heading>
                                <Heading
                                    size="desktop_heading_2"
                                    className="sm:hidden font-medium text-[#FFFFFF] leading-[48.4px] gap-4 whitespace-pre-line">
                                    {t("faq.sub_title")}
                                </Heading>
                                <Heading
                                    size="desktop_heading_4"
                                    className="lg:hidden md:hidden font-medium text-[#FFFFFF] leading-[48.4px] uppercase gap-4 whitespace-pre-line">
                                    {t("faq.sub_title")}
                                </Heading>

                            </div>
                            <Button
                                shape="round"
                                onClick={scrollToContactForm}
                                className="rounded-[12px] min-w-[320px] sm:w-full px-[34px] font-extrabold sm:px-[16px] flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap h-[56px] sm:h-[44px] text-[15px] bg-[#ffb800] hover:bg-[#FFC224] text-[#1b1f3b]"
                            >
                                {t("faq.button")}
                            </Button>
                        </div>
                        <div className="gap-10 mt-1 flex w-full flex-col items-start self-center">
                            {/* Контейнер с анимацией раскрытия/сжатия */}
                            <div
                                style={{
                                    maxHeight: showAll ? "10000px" : "1500px",
                                    transition:  "max-height 1s ease"
                                }}
                                className="overflow-hidden"
                            >
                                <Accordion
                                    preExpanded={[0]}
                                    onChange={handleAccordionChange}
                                    allowMultipleExpanded={true}
                                    allowZeroExpanded={true}
                                    className="flex-col self-stretch"
                                >
                                    {dataToShow.map((d, i) => (
                                        <AccordionItem uuid={i} key={`tuiaccordion${i}`}>
                                            <div className="flex-1">
                                                <div>
                                                    <AccordionItemHeading className="w-full">
                                                        <AccordionItemButton>
                                                            <AccordionItemState>
                                                                {(props) => (
                                                                    <>
                                                                        <div className="flex items-center justify-between gap-5 py-4">
                                                                            <Heading
                                                                                size="desktop_body_xl_bold"
                                                                                className="text-[#FFFFFF]"
                                                                            >
                                                                                {d.question}
                                                                            </Heading>
                                                                            <Img
                                                                                src={d.arrow}
                                                                                alt="Arrow Up"
                                                                                className={`h - [24px]  transform transition-transform duration-300
                                                                                ${props.expanded ? "rotate-180" : "rotate-0"}`}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </AccordionItemState>
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <div className="mb-5">
                                                            <Heading
                                                                size="desktop_body_xl"
                                                                className="text-[#FFFFFF] font-medium text"
                                                            >
                                                                {d.answer}
                                                            </Heading>
                                                        </div>
                                                    </AccordionItemPanel>

                                                    <div className="mt-3 h-px w-full bg-[#C5C5C5]"/>
                                                </div>
                                            </div>
                                        </AccordionItem>
                                    ))}
                                </Accordion>
                            </div>
                            <Button
                                color="#F4F4F4"
                                shape="round"
                                onClick={toggleShowAll}
                                rightIcon={
                                    <Img
                                        src={showAll ? "/images/img_icon24_up.svg" : "/images/img_icon24.svg"}
                                        alt="Arrow Down"
                                        className={`h-[24px] w-[24px] object-contain ${showAll ? "pt-0.5" : "pt-0"}`}
                                    />
                                }
                                className="min-w-[320px] md:w-[320px] sm:w-full sm:h-[44px] gap-0.5 px-[34px] font-extrabold bg-[#f4f4f4] hover:opacity-[92%]"
                            >
                                {showAll ? t("faq.close_button") : t("faq.expand_button")}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
